import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
  title: string;
  content: string;
  cancel: string;
  confirm: string;
  bigButtons?: boolean

  // Quando true, o botão de confirm vira `warn` (filled vermelho) ao invés
  // de `primary`, sinalizando ação destrutiva (descartar, deletar, etc.).
  // O cancel permanece neutro (stroked) — não inverte semântica como o
  // design antigo fazia.
  destructive?: boolean;

  // Valor retornado pelo botão CANCEL (default = undefined = mesmo que
  // backdrop/ESC). Use quando o cancel precisar ser distinto de dismiss
  // (ex.: 3-way "Salvar / Descartar / Continuar editando" — confirm=true,
  // cancel='discard', dismiss=undefined).
  cancelValue?: any;
  // Cosmético do botão cancel: 'destructive' o pinta como warn (filled
  // vermelho); default = stroked neutro.
  cancelStyle?: 'destructive';

  // Botão TERCIÁRIO opcional (leftmost). Uso típico: diálogo 3-way
  // save/discard/cancel — `neutral` = "Cancelar" (não navegar), `cancel` =
  // "Descartar" (destructive middle), `confirm` = "Salvar" (primary right).
  // Renderiza como stroked neutro; sem estilo destrutivo.
  neutral?: string;
  neutralValue?: any;

  params?: {
    title?: any,
    content?: any,
    onlyOkButton?: boolean
    isSuccessInfo?: boolean
  };
}

const justInformation = [
  'submissions.view.file-rules-card.details-dialog.title'
]

const useInnerContent = [
  'submissions.view.file-rules-card.details-dialog.title'
]

const messagesFormInvalidWithContent = [
  'messages.affiliation-not-found',
  'messages.country-not-found',
  'messages.country-affiliation-not-found',
]

const messagesFormInvalidWithNotContent = [
  'messages.profile-incomplete',
  'messages.affiliation-form-invalid',
  'errors.file.max-size'
]

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent implements OnInit {
  notContentMessage: boolean = false;
  isMessageNotFoundInfo: boolean = false;
  isSuccessDialog: boolean = false;
  useInnerContent = false;
  justInformation = false;
  bigButtons: boolean = false;

  dialogMessages: DialogData = {
    title: 'confirmation-dialog.title',
    content: 'confirmation-dialog.content',
    cancel: 'forms.buttons.cancel',
    confirm: 'forms.buttons.confirm',
    bigButtons: false,
    params: {},
  };

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    if (data) {
      Object.assign(this.dialogMessages, data);
    }
  }

  ngOnInit(): void {
    const titleMessage = this.dialogMessages.title;
    const onlyOkButton = this.dialogMessages.params?.onlyOkButton;
    this.bigButtons = this.dialogMessages.bigButtons;

    if (onlyOkButton) {
      this.isMessageNotFoundInfo = true;
      this.isSuccessDialog = this.dialogMessages.params?.isSuccessInfo;
    } else {
      messagesFormInvalidWithContent.filter((message: string) => {
        if (titleMessage === message) {
          this.isMessageNotFoundInfo = true;
        }
      });
    }


    messagesFormInvalidWithNotContent.filter((message: string) => {
      if (titleMessage === message) {
        this.notContentMessage = true;
      }
    });

    justInformation.filter((message: string) => {
      if (titleMessage === message) {
        this.isMessageNotFoundInfo = false;
        this.justInformation = true;
      }
    });

    useInnerContent.filter((message: string) => {
      if (titleMessage === message) {
        this.useInnerContent = true;
      }
    });
  }
}
